export enum ImportType {
  CUSTOMER_QUOTE = 'customerQuote',
  JOB = 'job',
  VENDOR_QUOTE = 'vendorQuote',
}

export enum ImportStep {
  IMPORT_FILE = 'importFile',
  MAPPING = 'mapping',
  PREVIEW = 'preview',
  SOLVE_PROBLEMS = 'solveProblems',
  UPLOAD_FILE = 'uploadFile',
}

export enum ImportRowStatus {
  FAILED = 'failed',
}

export enum ImportLineMode {
  ADD_ALL = 'addAll',
  UPDATE_MATCHING = 'updateMatching',
}

export enum SolveProblemsStep {
  ASSIGN_MANUFACTURERS = 'assignManufacturers',
  MEASURE_CONFLICT = 'measureConflict',
  MULTIPLE_MANUFACTURERS = 'multipleManufacturers',
  UNKNOWN_MANUFACTURERS = 'unknownManufacturers',
}

export enum ManufacturerValidationStatus {
  MULTIPLE_MANUFACTURERS = 'multiple_manufacturers',
  NO_MANUFACTURER = 'no_manufacturer',
  UNKNOWN = 'unknown',
  VALID = 'valid',
}

export enum UomValidationStatus {
  MISMATCH = 'mismatch',
  UNKNOWN = 'unknown',
  VALID = 'valid',
}

export enum ImportHeader {
  COST = 'cost',
  COST_SOURCE = 'costSource',
  CUSTOMER_PART_NUMBER = 'customerPartNumber',
  DESCRIPTION = 'description',
  ITEM = 'item',
  LEAD_TIME_NOTE = 'leadTimeNote',
  MANUFACTURER = 'manufacturer',
  NOTES = 'notes',
  NUMBER = 'number',
  PRICE = 'price',
  QUANTITY = 'quantity',
  REPLACEMENT_COST = 'replacementCost',
  UOM = 'uom',
  VENDOR_QUOTE_NUMBER = 'vendorQuoteNumber',
}
